// File generated from our OpenAPI spec
import { StripeResource } from '../StripeResource.js';
const stripeMethod = StripeResource.method;
export const AccountSessions = StripeResource.extend({
    create: stripeMethod({ method: 'POST', fullPath: '/v1/account_sessions' }),
});
